import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import "assets/css/depact.css"

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import 'react-chat-elements/dist/main.css';
// core components
import Super from "layouts/Super.js";
import Auth from "layouts/Auth.js";
import Info from "layouts/Info.js";
//redux
import { createStore } from 'redux';
import allReducers from "pages/redux/reducers";
import { Provider } from 'react-redux';
//to persist login
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { PersistGate } from 'redux-persist/lib/integration/react';
import LoadingView from "layouts/LoadingView.js";

//persist config
const persistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  blacklist: ['cartManager', 'loginPage', 'searchFilter']
};
const pReducer = persistReducer(persistConfig, allReducers);

//redux store 
const myStore = createStore(
  pReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

//persistor
const persistor = persistStore(myStore);

//original index content begins
const hist = createBrowserHistory();

ReactDOM.render(
  <Provider store={myStore}>
    <PersistGate loading={<LoadingView />} persistor={persistor}>
      <Router history={hist}>
        <Switch>
          <Route path="/auth" component={Auth} />
          <Route path="/main" component={Super} />
          <Route path="/info" component={Info} />
          <Redirect from="/" to="/auth/login" />
        </Switch>
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
